import React from 'react';
import { STATUS, marginText } from './calendarLogic';

export const StatusBadge = ({ pl, testId }) => {
  const s = STATUS[pl.status];
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold whitespace-nowrap ${s.badge}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot} ${pl.status === 'late' ? 'animate-pulse' : ''}`} />
      {marginText(pl)}
    </span>
  );
};
